import styled from "styled-components";
import { ReactComponent as Cross } from "../../../../assets/img/icons/cross.svg";
import { ReactComponent as Search_icon } from "../../../../assets/img/icons/search.svg";
import PlusIcon from "../../../../assets/img/icons/Article/Plus.svg";

const Wrapper = styled.div`
  border-radius: 15px;
  cursor: pointer;
  background: #001760;
  border: 1px solid #dadada;
  padding: 7px 9px;
  display: inline;
  float: left;
  transition: 0.5s;
  margin-top: 4px;
  margin-right: 7px;
  &.exclude {
    .item-label {
      color: #9f0000;
    }
    .clear-item svg circle {
      fill: #9f0000;
      fill-opacity: 1;
    }
    .search-icon svg path {
      fill: #9f0000;
    }
  }
  .item-label {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    font-family: "robotomedium", sans-serif;
    float: left;
    line-height: 16px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 10px;
      line-height: 6px;
    }
  }
  .search-icon {
    margin-right: 15px;
    float: left;
    svg {
      float: left;
    }
  }
  .clear-item {
    margin-left: 12px;
    float: left;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-left: 7px;
    }
    svg {
      width: 15px;
      height: 16px;
      float: left;
      circle {
        fill: #001760;
        fill-opacity: 1;
      }
    }
  }
`;
const SearchTermExtended = (props) => {
  return (
    <>
      <Wrapper className={`collapsable-search ${props.style}`}>
        <span className="item-label" onClick={props.onClick}>
          {props.count}
        </span>
      </Wrapper>
    </>
  );
};

export default SearchTermExtended;
